import React from 'react';
import { ArrowRight, MapPin, Phone, Clock } from 'lucide-react';
import { units, whatsappLink, brand } from '../data/mock';
import { SectionLabel } from './About';

const Units = () => {
  const u = units[0];
  return (
    <section id="unidade" className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <SectionLabel>Unidade BRN</SectionLabel>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-12">
          <div className="md:col-span-7">
            <h2 className="font-display text-[44px] sm:text-[60px] md:text-[76px] leading-[1.04] text-cream">
              Onde a <span className="text-cream/55">BRN acontece</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-cream-soft text-[15px] md:text-[16px] leading-relaxed">
              Um ambiente pensado em cada detalhe: limpo, moderno e com a essência BRN. Venha viver a experiência
              que transforma minutos de cuidado em horas de confiança.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* Image card */}
          <div className="lg:col-span-7 relative rounded-2xl overflow-hidden aspect-[16/11] group">
            <img src={u.image} alt={u.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b0807] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
              <div>
                <p className="text-cream/60 text-[11px] tracking-[0.3em] uppercase mb-1">Jundiaí — SP</p>
                <h3 className="font-display text-[30px] md:text-[36px] text-cream leading-tight">{u.name}</h3>
              </div>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center rounded-full bg-cream text-[#0b0807] px-5 py-2 text-[13px] font-medium hover:bg-white transition-colors"
              >
                Agendar <ArrowRight className="w-3.5 h-3.5 ml-2" />
              </a>
            </div>
          </div>

          {/* Info card */}
          <div className="lg:col-span-5 rounded-2xl border border-cream/10 bg-[#120e0c] p-7 md:p-9 flex flex-col">
            <h4 className="font-display text-[26px] md:text-[30px] text-cream mb-6">Informações</h4>

            <div className="space-y-6 flex-1">
              <div className="flex items-start gap-4">
                <span className="mt-1 w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4 text-cream/80" />
                </span>
                <div>
                  <p className="text-cream/55 text-[11px] tracking-[0.25em] uppercase mb-1">Endereço</p>
                  <p className="text-cream text-[14.5px] leading-relaxed">{u.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <span className="mt-1 w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4 text-cream/80" />
                </span>
                <div>
                  <p className="text-cream/55 text-[11px] tracking-[0.25em] uppercase mb-1">Telefone / WhatsApp</p>
                  <a href={`tel:+${brand.phoneRaw}`} className="text-cream text-[14.5px] hover:text-white">{brand.phone}</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <span className="mt-1 w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-4 h-4 text-cream/80" />
                </span>
                <div>
                  <p className="text-cream/55 text-[11px] tracking-[0.25em] uppercase mb-1">Horário</p>
                  <p className="text-cream text-[14.5px]">Seg — Sex · 09h às 20h</p>
                  <p className="text-cream text-[14.5px]">Sábado · 09h às 17h</p>
                </div>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/search/?api=1&query=Rua+Oswaldo+Cruz+250+Ponte+Sao+Joao+Jundiai"
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex items-center justify-center w-fit rounded-full border border-cream/25 px-6 py-2.5 text-sm text-cream hover:bg-cream hover:text-[#0b0807] transition-colors"
            >
              Ver no mapa
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Units;
